<template>
  <main>
    <div class="organism-all-event_container">
      <section class="container__header">
        <label class="container__header--topic text--topic mb-1"
          >All Event</label
        >
        <organism-all-event-filter
          v-model="datepicker"
          :filterList="filterList"
          :equipmentList="equipmentList"
          :tagList="tagList"
          :resourceTypeList="resourceTypeList"
          @clickFilter="clickFilter"
          @onSetDefaultFilterData="onSetDefaultFilterData"
        ></organism-all-event-filter>
      </section>
      <hr />
      <section class="container__content mb-8">
        <molecule-data-table
          v-model="inputSearch"
          :fields="fields"
          :items="items"
          :isCustomized="true"
          :enabledSelect="false"
          :enabledSearch="true"
          :isShowPagination="true"
          placeholderSearch="Filter Events"
          maxHeight="568px"
        >
          <template #time="data">
            <span class="text--normal pl-1">{{ data.row.date }}</span> <br />
            <span class="text--light pl-1">{{ data.row.time }}</span>
          </template>
          <template #equipment="data">
            <div class="d-flex">
              <span class="text--bold">{{ data.row.equipmentName }}</span>
              <div :id="'tag-popover' + data.row.originalIndex">
                <feather-icon
                  icon="TagIcon"
                  size="12"
                  class="tag-icon--style"
                />
              </div>
              <b-popover
                ref="popover"
                :target="'tag-popover' + data.row.originalIndex"
                triggers="hover"
                placement="right"
                container="my-container"
                boundary="window"
              >
                <template v-slot:title>
                  <div class="d-flex justify-content-between align-items-left">
                    <span>Tag</span>
                  </div>
                </template>
                <div class="badge__container">
                  <b-badge
                    v-for="(tag, index) in data.row.tag"
                    :key="index"
                    variant="light-primary"
                    class="badge--style tag--space"
                  >
                    {{ tag }}
                  </b-badge>
                </div>
              </b-popover>
            </div>

            <span class="text--light">{{ data.row.equipmentIp }}</span>
          </template>
          <template #resources="data">
            <b-badge
              pill
              :variant="badgeVariant(data.row.status)"
              class="badge--width"
            >
              {{ data.row.resources }}
            </b-badge>
          </template>
          <template #value="data">
            <div class="value__container">
              <div
                class="text--normal mr-1 text--width mr-1 d-flex justify-content-end"
              >
                {{ data.row.value + " " + policyUnit(data.row.policyUnit) }}
              </div>
              <div :id="'alert-icon' + data.row.originalIndex">
                <feather-icon
                  icon="AlertTriangleIcon"
                  class="alert__icon--active"
                />
              </div>
              <b-tooltip
                :target="'alert-icon' + data.row.originalIndex"
                placement="right"
                boundary="window"
                variant="warning"
              >
                <div class="textbox__warning-value--style">
                  <span>Warning</span>
                  <span>{{
                    data.row.warningValue
                      ? data.row.warningValue +
                        " " +
                        policyUnit(data.row.policyUnit)
                      : "-"
                  }}</span>
                </div>
                <div class="textbox__danger-value--style">
                  <span>Critical</span>
                  <span>{{
                    data.row.criticalValue
                      ? data.row.criticalValue +
                        " " +
                        policyUnit(data.row.policyUnit)
                      : "-"
                  }}</span>
                </div>
              </b-tooltip>
            </div>
          </template>
          <template #description="data">
            {{ data.row.description }}
          </template>
        </molecule-data-table>
      </section>
    </div>
    <footer style="height: 28px"></footer>
  </main>
</template>

<script>
import { BBadge, BPopover, VBTooltip, BTooltip } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import MoleculeDataTable from "@/components/molecules/MoleculeDataTable.vue"
import OrganismAllEventFilter from "./OrganismAllEventFilter.vue"
export default {
  name: "OrganismAllEvent",
  components: {
    BBadge,
    MoleculeDataTable,
    OrganismAllEventFilter,
    BPopover,
    BTooltip,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  props: {
    equipmentList: {
      type: Array,
      required: true,
    },
    tagList: {
      type: Array,
      required: true,
    },
    resourceTypeList: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
      default: [],
    },
    items: {
      type: Array,
      required: false,
      default: [],
    },
    filterList: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inputSearch: "",
      currentHoverRowIndex: null,
    }
  },
  computed: {
    datepicker: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    policyUnit(unit) {
      if (unit.toLowerCase() !== "percent") return unit
      else return "%"
    },
    badgeVariant(status) {
      if (status === 0) return "light-primary"
      else if (status === 1) return "light-warning"
      else return "light-danger"
    },
    clickFilter(filter) {
      this.$emit("onUpdateFilterData", filter)
    },
    onSetDefaultFilterData() {
      this.$emit("onSetDefaultFilterData")
    },
  },
}
</script>

<style lang="scss" scoped>
.max--height {
  height: 100vh;
  background-color: teal;
}

.organism-all-event_container {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.container__header {
  display: block;
  padding: 20px 26px 0 26px;
  border-radius: 6px 0;
  background-color: #ffffff;
}

.container__content {
  line-height: 1.25;
  height: 100%;
}

.text--topic {
  font-weight: 500;
  font-size: 18px;
}

.text--bold {
  font-weight: 600;
  font-size: 14px;
}

.text--normal {
  font-weight: 400;
  font-size: 14px;
}

.text--light {
  color: #b9b9c3;
  font-weight: 400;
  font-size: 12px;
}

.tag-icon--style {
  color: #9d95f5;
  margin-left: 8px;
  margin-bottom: 3px;
}

.badge__container {
  min-width: 200px;
  width: auto;
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag--space {
  margin-left: 4px;
  margin-bottom: 4px;
}

.value__container {
  display: flex;
}

.alert__icon--style {
  margin-bottom: 5px;
  color: #fff;
}

.alert__icon--active {
  color: #b9b9c3;
}

.textbox__warning-value--style {
  display: flex;
  justify-content: space-between;
  color: #ff9f43;
  font-weight: 400;
  font-size: 14px;
}

.textbox__danger-value--style {
  display: flex;
  justify-content: space-between;
  color: #ea5455;
  font-weight: 400;
  font-size: 14px;
}

.badge--width {
  width: 75px;
}

.organism-all-event_container ::v-deep {
  .molecule-datatable--header-search-container {
    justify-content: center;
    padding: 0 1.5rem 0 1.5rem;
    margin-top: 25px;
  }
  .molecule-datatable--pagination {
    display: flex;
    justify-content: center;
    padding: 0 26px;
  }
}

.text--width {
  width: 75px;
}

@media screen and (min-width: 768px) {
  .organism-all-event_container ::v-deep {
    .molecule-datatable--header-search-container {
      justify-content: flex-end;
      padding-right: 24px;
      margin-top: 25px;
    }
    .molecule-datatable--pagination {
      display: flex;
      justify-content: space-between;
      padding: 0 26px;
    }
  }
}
</style>
